import PropTypes from 'prop-types'
import { createConnectionProps } from '../helpers/connectionHelpers'

// Renders all connection lines between nodes
const FlowConnections = ({ links }) => {
  return (
    <g>
      {links.map((link, index) => (
        <path key={`connection-${index}`} {...createConnectionProps(link)} />
      ))}
    </g>
  )
}

FlowConnections.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        w: PropTypes.number.isRequired,
        h: PropTypes.number.isRequired
      }).isRequired,
      to: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        w: PropTypes.number.isRequired,
        h: PropTypes.number.isRequired
      }).isRequired,
      color: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired
}

export default FlowConnections
